import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const Aura = ({size, className, id}) => {
  let ratio = size / 100;
  
  let width = size,
      height = 63 * ratio;
      
  let _attributes = {
    width: width || 100,
    height: height || 63,
    viewBox: "0 0 100 63"
  };
  
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(className);
  }
  
  return (
    <svg {..._attributes}>
      <g transform="translate(-1095.5 -560.5)">
        <rect width="100" height="63" transform="translate(1095.5 560.5)" fill="none"/>
        <g transform="translate(1114.515 572.472)">
          <g>
            <path d="M0,0H61.79l.066,19.256C54.4,16.419,30.664,9.629,0,18.09Z" fill="#2c328c" fillRule="evenodd"/>
            <path d="M0,105.154H61.79V89.748C50.646,86.019,30.837,80.43,0,88.348Z" transform="translate(0 -64.308)" fill="#fff200" fillRule="evenodd"/>
            <path d="M61.79,70.373c-11.144-3.73-30.953-9.318-61.79-1.4V63.023c30.664-8.461,54.4-1.662,61.856,1.166Z" transform="translate(0 -44.933)" fill="#ed1c24" fillRule="evenodd"/>
            <path d="M82.91,35.753a11.188,11.188,0,0,1,11.108-7.834c6.08.04,10.135,3.514,11.229,8.058A106.523,106.523,0,0,0,82.91,35.753Z" transform="translate(-63.227 -21.291)" fill="#fff200" fillRule="evenodd"/>
            <path d="M58.15,119.353l4.138-6.173h1.524l4.409,6.173H66.606l-1.256-1.868H60.84l-1.187,1.868Zm3.108-2.533h3.654l-1.125-1.707a12.822,12.822,0,0,1-.762-1.28,5.569,5.569,0,0,1-.582,1.187l-1.187,1.807Zm14.211,2.533V118.7a3.767,3.767,0,0,1-2.479.757,5.274,5.274,0,0,1-1.289-.15,2.407,2.407,0,0,1-.888-.38,1.218,1.218,0,0,1-.408-.56,2.3,2.3,0,0,1-.081-.712v-2.766h1.322v2.476a2.611,2.611,0,0,0,.081.8.931.931,0,0,0,.529.475,2.6,2.6,0,0,0,1,.169,3.5,3.5,0,0,0,1.116-.173,1.425,1.425,0,0,0,.738-.475,1.477,1.477,0,0,0,.218-.874v-2.4h1.322v4.466Zm4.392,0v-4.466h1.187v.677a2.512,2.512,0,0,1,.843-.627,2.3,2.3,0,0,1,.848-.152,4.078,4.078,0,0,1,1.36.237l-.456.712a2.958,2.958,0,0,0-.969-.166,1.954,1.954,0,0,0-.781.15.981.981,0,0,0-.491.415,1.8,1.8,0,0,0-.221.883v2.338Zm11.27-.551a6.411,6.411,0,0,1-1.424.506,6.938,6.938,0,0,1-1.46.147,4.383,4.383,0,0,1-1.978-.358,1.053,1.053,0,0,1-.691-.919.84.84,0,0,1,.261-.6,1.854,1.854,0,0,1,.681-.434,4.678,4.678,0,0,1,.95-.237c.259-.038.65-.078,1.173-.114A20.119,20.119,0,0,0,91,116.53v-.2a.667.667,0,0,0-.375-.65,3.423,3.423,0,0,0-1.505-.256,3.8,3.8,0,0,0-1.379.188,1.234,1.234,0,0,0-.658.662l-1.291-.1a1.626,1.626,0,0,1,.579-.767,3.053,3.053,0,0,1,1.168-.451,8.849,8.849,0,0,1,1.771-.157,7.987,7.987,0,0,1,1.624.135,2.673,2.673,0,0,1,.921.339,1.1,1.1,0,0,1,.411.515,2.538,2.538,0,0,1,.064.7V117.5a6.036,6.036,0,0,0,.085,1.334,1.318,1.318,0,0,0,.335.537H91.37a1.133,1.133,0,0,1-.264-.551Zm-.112-1.69a15.924,15.924,0,0,1-2.16.287,8.168,8.168,0,0,0-1.154.15,1.2,1.2,0,0,0-.522.237.475.475,0,0,0-.185.358c0,.2.135.37.4.506a2.692,2.692,0,0,0,1.17.2,4.433,4.433,0,0,0,1.36-.19,1.862,1.862,0,0,0,.876-.525,1.154,1.154,0,0,0,.214-.757Z" transform="translate(-44.345 -86.31)" fill="#2c328c" stroke="#2c328c" strokeMiterlimit="22.93" strokeWidth="0.22"/>
          </g>
        </g>
      </g>
    </svg>
  );
};

Aura.defaultProps = {
  size: 100,
  className: "",
  id: ""
};

Aura.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
